import { useCallback } from 'react';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import useUser from '@ubeya/shared/hooks/auth/useUser';
import { trackEvent } from '@ubeya/shared-web/analytics/amplitude';

export const useHelpDeskAnalytics = () => {
  const { accountId } = useAccount();
  const { data: { id: adminId } = {} } = useUser();

  const trackHelpDeskEvent = useCallback(
    ({ eventName, context, eventProperties = {} }) => {
      trackEvent(eventName, {
        module: 'Help Desk',
        context,
        adminId,
        accountId,
        ...eventProperties
      });
    },
    [accountId, adminId]
  );

  const trackHelpDeskTicketEvent = useCallback(
    ({ eventName, context, ticket, ticketStatus, snoozedUntil, eventProperties = {} }) => {
      if (!ticket) return;

      trackHelpDeskEvent({
        eventName,
        context,
        eventProperties: {
          ticketStatus,
          categoryId: ticket.categoryId,
          priority: ticket.priority,
          assignedAdminId: ticket.assignedAdminId,
          branchId: ticket.branchId,
          ticketId: ticket.id,
          relatedShiftId: ticket.shiftId,
          snoozedUntil,
          ...eventProperties
        }
      });
    },
    [trackHelpDeskEvent]
  );

  // Fired from the click handler that opens the admin create-ticket modal; `context` is the entry point.
  const trackCreateTicketOpened = useCallback(
    (context) => trackHelpDeskEvent({ eventName: 'Help desk - Admin creates a ticket', context }),
    [trackHelpDeskEvent]
  );

  return {
    trackHelpDeskEvent,
    trackHelpDeskTicketEvent,
    trackCreateTicketOpened
  };
};
